import { render, staticRenderFns } from "./taxProve.vue?vue&type=template&id=61771ea7&scoped=true&"
import script from "./taxProve.vue?vue&type=script&lang=js&"
export * from "./taxProve.vue?vue&type=script&lang=js&"
import style0 from "./taxProve.vue?vue&type=style&index=0&id=61771ea7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61771ea7",
  null
  
)

export default component.exports